import React from 'react';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import TextStatusIndicator from 'Views/Page/Content/Templates/WhatIfTemplate/Components/TextStatusIndicator';
import moment from 'moment-timezone';
import {
  dayOfAbreviatedMonthNoYear,
  shortDatetime,
} from 'Consts/DateFormats';
import {
  useScenarioLoadingContext,
} from 'Views/Page/Content/Templates/WhatIfTemplate/Content/LeftSide/Content/Header/ScenarioLoadingIndicator/ScenarioLoadingContext';

const ScenarioLoadingIndicator = () => {
  const { pageContentResource } = usePageContentContext();
  const { isScenarioLoading, hasLoadingError } = useScenarioLoadingContext();
  let loadingState = 'loading';
  let textStatusLabel = 'Updating roadmap...';

  if (hasLoadingError) {
    loadingState = 'error';
    textStatusLabel = `Update Failed ${moment().format(shortDatetime)}`;
  }

  if (!isScenarioLoading) {
    loadingState = 'loaded';
    textStatusLabel = `Last Updated ${moment.utc(pageContentResource.attr('lastUpdated')).local().format(shortDatetime)}, Start Date ${moment.utc(pageContentResource.attr('simulationStartDate')).utc().format(dayOfAbreviatedMonthNoYear)}`;
  }

  return <TextStatusIndicator test="facet-plan-loading-indicator" label={textStatusLabel} loadingState={loadingState} />;
};

ScenarioLoadingIndicator.defaultProps = {};

ScenarioLoadingIndicator.propTypes = {};

export default ScenarioLoadingIndicator;
